module.exports = __webpack_public_path__ + "static/media/BannerCongresoMobileES.f870a56c.jpg";